import { FC } from 'react';

import classNames from 'classnames';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import DropDownClick, { DownPlacement } from 'bloko/blocks/drop/Down/Click';
import Link from 'bloko/blocks/link';

// @ts-expect-error TS7016
import AccountLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/AccountLink';
// @ts-expect-error TS7016
import EmployerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/EmployerLink';
// @ts-expect-error TS7016
import ActError from 'components/Admin/Reports/ActsReport/ActsTable/Act/ActError';
import Amount from 'components/Admin/Reports/ActsReport/ActsTable/Act/Amount';
// @ts-expect-error TS7016
import Invoices from 'components/Admin/Reports/ActsReport/ActsTable/Act/Invoices';
import { ActStatus, ActType } from 'components/Admin/Reports/ActsReport/Labels';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { Act as ActModel, ActStatus as ActStatusEnum } from 'store/models/acts';

interface ActProps {
    act: ActModel;
    showDate?: boolean;
}

const Act: FC<ActProps> = ({ act, showDate = false }) => {
    const { actDate, actName, amount, correctedAmount, accountId, type, status, employerId, invoices, error } = act;

    return (
        <TableRow className={classNames('act', { [`act_wait`]: status === ActStatusEnum.Waiting1C })}>
            {showDate && <TableCell>{formatDate(actDate, VIEW_DATE_FORMAT)}</TableCell>}
            <TableCell>
                <DropDownClick
                    showCloseButton
                    render={() => <Invoices invoices={invoices} />}
                    placement={DownPlacement.BottomStart}
                >
                    <Link>{actName}</Link>
                </DropDownClick>
            </TableCell>
            <TableCell>
                <EmployerLink employerId={employerId} />
            </TableCell>
            <TableCell>
                <AccountLink accountId={accountId} />
            </TableCell>
            <TableCell>
                <Amount amount={amount} correctedAmount={correctedAmount} />
            </TableCell>
            <TableCell>
                <ActType type={type} />
            </TableCell>
            <TableCell>
                <ActStatus status={status} />
            </TableCell>
            <TableCell>{error && <ActError text={error} />}</TableCell>
        </TableRow>
    );
};

export default Act;
